import { makeStub } from "./_base";
export const InventoryStock = makeStub("InventoryStock");
